import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';

export const NewPasswordPage = withSuspense(lazy(() => import('./new-password-page.component')));
